import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UndoEnrollmentReviewMutation = graphql.persisted(
  "UndoEnrollmentReview",
  graphql(`
    mutation UndoEnrollmentReview($familyEnrollmentId: ID!) {
      undoEnrollmentReview(input: { familyEnrollmentId: $familyEnrollmentId }) {
        familyEnrollment {
          id state approvedAt
          studentEnrollments { id state person { id firstName lastName } }
          invoices { id status amountCents dueDate key }
        }
        userErrors { message path }
      }
    }
  `)
);

export { UndoEnrollmentReviewMutation };

export function useUndoEnrollmentReview() {
  return useMutation(UndoEnrollmentReviewMutation);
}
